import { TranslatePipe } from "@ngx-translate/core";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { ComponentAdapterCounterDistributor } from "src/components/shared-components/class/adapters/component-adapter-counter-distributor";
import { GenericCounterGraphData } from "src/components/shared-components/class/generic-counter-graph-data";
import { WidgetCounterParent } from "src/components/shared-components/class/widget-counter-parent";
import { DistributorCounterMeasurementType } from "src/components/shared-components/enum/enumCounterMeasurementType";

import { ChartSerieKind } from "src/components/shared-components/enum/enumChart";
import { SkillNameList } from "src/components/shared-components/enum/enumSkillNameList";
import { CounterDistributionConsumption } from "src/components/shared-components/class/counter-distribution-consumption";
import { SmartComponentSummaryData } from "src/components/shared-components/class/smart-components/smart-component-property-details";
import { WidgetCounterSkillExpandableComponent } from "../../widget-counter-skill-expandable/widget-counter-skill-expandable.component";
import { WidgetCounterBandComponent } from "../../widget-counter-band/widget-counter-band.component";
import { WidgetCounterBandTripleComponent } from "../../widget-counter-band-triple/widget-counter-band-triple.component";

@Component({
    selector: "app-counter-heat-allocator",
    templateUrl: "./counter-heat-allocator.component.html",
    styleUrls: ["./counter-heat-allocator.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [WidgetCounterSkillExpandableComponent, WidgetCounterBandComponent, WidgetCounterBandTripleComponent, TranslatePipe]
})

/**
 * Counter heat allocator entry componet
 */
export class CounterHeatAllocatorComponent extends WidgetCounterParent<ComponentAdapterCounterDistributor> {
  public chartSerieKind = ChartSerieKind;
  public showBandConsumption: boolean = false;
  public umConsumption: string = "";
  public chartBarConsumption: GenericCounterGraphData =
    new GenericCounterGraphData();
  public consumptionDistribution: CounterDistributionConsumption[] = null;
  public chartBarConsumptionCSV: string = "";

  public previousMonthValue: string = "";
  public previousyearValue: string = "";
  public currentyearValue: string = "";
  public allocatorUrPreviousMonth: string = "";
  public allocatorUrCurrentMonth: string = "";
  public allocatorUrPreviousYear: string = "";
  public allocatorUrCurrentYear: string = "";
  public errorChartConsumption: boolean = false;
  public skillType = SkillNameList;
  @Input() public headerSummary: SmartComponentSummaryData = null;

  protected async onComponentLoad(): Promise<void> {
    this.setMeasurements();

    try {
      await this._loaderService.presentLoaderWaiting();
      if (this.componentAdapter.Consumption) {
        this.umConsumption = this.componentAdapter.Consumption.measureUnit;
        this.showBandConsumption = true;

        try {
          if (this.componentAdapter.Summary) {
            this.chartBarConsumption =
              await this.getSummaryYearlyForMonthConsumption(
                this.componentAdapter.IdEnvironment,
                this.componentAdapter.IdSmartComponentKind,
                SkillNameList.COUNTER_DISTRIBUTOR_CONSUMPTION
              );
            this.chartBarConsumption = this.roundChartData(
              this.chartBarConsumption,
              true
            );
            if (this.chartBarConsumption.data.length === 0) {
              this.showBandConsumption = false;
            }
            this.chartBarConsumptionCSV =
              await this.getSummaryYearlyForMonthConsumptionCSV(
                this.componentAdapter.IdEnvironment,
                this.componentAdapter.IdSmartComponentKind,
                SkillNameList.COUNTER_DISTRIBUTOR_CONSUMPTION
              );
          } else {
            this.chartBarConsumption = await this.getYearlyForMonthConsumption(
              this.componentAdapter.Consumption.address,
              this.componentAdapter.Consumption.instanceGUID
            );
            this.chartBarConsumption = this.roundChartData(
              this.chartBarConsumption,
              true
            );
            this.chartBarConsumptionCSV =
              await this.getYearlyForMonthConsumptionCSV(
                this.componentAdapter.Consumption.address,
                this.componentAdapter.Consumption.instanceGUID
              );
          }
        } catch {
          this.errorChartConsumption = true;
        }
      }
    } finally {
      await this._loaderService.dismissLoaderWaiting();
    }
  }

  protected onComponentDestroy(): void {}

  /**
   * This method set the displayed data defined throught the current "Measurements" associated to the
   * SmartComponent associated to this Widget.
   */
  private setMeasurements(): void {
    this.previousMonthValue = this.componentAdapter.PreviousMonth;
    this.previousyearValue =
      this._translateService.instant("dictionary.year") + " " + this.componentAdapter.PreviousYear;
    this.currentyearValue =
      this._translateService.instant("dictionary.year") + " " + this.componentAdapter.CurrentYear;

    this.allocatorUrPreviousMonth =
      this.componentAdapter.MeasurementMap.get(
        DistributorCounterMeasurementType[
          DistributorCounterMeasurementType
            .DISTRIBUTOR_CONSUMPTION_PREVIOUS_MONTH
        ]
      ) || "---";
    this.allocatorUrCurrentMonth =
      this.componentAdapter.MeasurementMap.get(
        DistributorCounterMeasurementType[
          DistributorCounterMeasurementType.DISTRIBUTOR_CONSUMPTION_LAST_MONTH
        ]
      ) || "---";
    this.allocatorUrPreviousYear =
      this.componentAdapter.MeasurementMap.get(
        DistributorCounterMeasurementType[
          DistributorCounterMeasurementType
            .DISTRIBUTOR_CONSUMPTION_PREVIOUS_YEAR
        ]
      ) || "---";
    this.allocatorUrCurrentYear =
      this.componentAdapter.MeasurementMap.get(
        DistributorCounterMeasurementType[
          DistributorCounterMeasurementType.DISTRIBUTOR_CONSUMPTION_LAST_YEAR
        ]
      ) || "---";
  }
}
